module.exports = __webpack_public_path__ + "media/images/woman-success-cropped-e900ad0ff8fa87cf91bf46a409d722a1.png";